import * as yup from 'yup';
import { CompoundOptions } from '../CompoundPage.hooks';

export const INITIAL_VALUES: CompoundOptions = {
  initialAsset: 10_000_000,
  monthlyContribution: 500_000,
  investFrequency: 12,
  period: 20,
  annualReturnRate: 7,
};

export const investFrequencyMap: Record<number, string> = {
  12: '매월',
  4: '매분기',
  1: '매년',
};

export const schema = yup.object().shape({
  initialAsset: yup.number().min(0, '0 이상의 값을 입력해 주세요.').required('필수 입력 항목입니다.'),
  monthlyContribution: yup.number().min(0, '0 이상의 값을 입력해 주세요.').optional().default(0),
  investFrequency: yup.number().oneOf([1, 4, 12]).required('투자 주기를 선택해주세요.'),
  period: yup
    .number()
    .min(1, '최소 1년 이상이어야 합니다.')
    .max(50, '최대 50년까지 입력할 수 있습니다.')
    .required('필수 입력 항목입니다.'),
  annualReturnRate: yup
    .number()
    .min(0, '0% 이상을 입력해 주세요.')
    .max(50, '수익률은 50% 이하로 입력해 주세요.')
    .required('필수 입력 항목입니다.'),
});
